import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoProjeto, ServicoProjetoAberturaIdentificacao, ServicoProjetoTipo, ServicoProjetoTipoCaptura, ServicoProjetoTipoIdentificacao } from '../../servicos/srv.projeto';

@Component({
  selector: 'tsv2-prj-adicionar',
  templateUrl: './adicionar.component.html',
  providers: [ ServicoMsg, ServicoProjeto, ServicoProjetoAberturaIdentificacao, ServicoProjetoTipo, ServicoProjetoTipoCaptura, ServicoProjetoTipoIdentificacao ]
})
export class ProjetoAdicionarComponent implements OnInit {
  exibirBarra: boolean = true;

  tipos: any;
  tiposAbertura: any;
  tiposCaptura: any;
  tiposIdentificacao: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    // private spinner: NgxSpinnerService,
    private servicoMsg: ServicoMsg,
    private servicoProjeto: ServicoProjeto,
    private servicoProjetoAberturaIdentificacao: ServicoProjetoAberturaIdentificacao,
    private servicoProjetoTipo: ServicoProjetoTipo,
    private servicoProjetoTipoCaptura: ServicoProjetoTipoCaptura,
    private servicoProjetoTipoIdentificacao: ServicoProjetoTipoIdentificacao
  ) { }

  ngOnInit() {
    // this.spinner.show();
    this.servicoProjetoAberturaIdentificacao.listarProjetoAberturaIdentificacao({}).subscribe(rsp => {
      this.tiposAbertura = rsp.lista;
      this.servicoProjetoTipo.listarProjetoTipo({}).subscribe(rsp => {
        this.tipos = rsp.lista;
        this.servicoProjetoTipoCaptura.listarProjetoTipoCaptura({}).subscribe(rsp => {
          this.tiposCaptura = rsp.lista;
          this.servicoProjetoTipoIdentificacao.listarProjetoTipoIdentificacao({}).subscribe(rsp => {
            this.tiposIdentificacao = rsp.lista;
            // this.spinner.hide();
          }, (err) => {
            // this.spinner.hide();
            this.servicoMsg.exibeErro(err).then(r1 => {});
          });
        }, (err) => {
          // this.spinner.hide();
          this.servicoMsg.exibeErro(err).then(r1 => {});
        });
      }, (err) => {
        // this.spinner.hide();
        this.servicoMsg.exibeErro(err).then(r1 => {});
      });
    }, (err) => {
      // this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

  adicionarProjeto(frmValues){
    // this.spinner.show();
    this.servicoProjeto.adicionarProjeto(frmValues).subscribe(id => {
      let url = '/projeto/visualizar/' + id;
      // this.spinner.hide();
      this.servicoMsg.exibeSucesso('Criado!', 'Projeto criado com sucesso!').then(r1 => {
        if (r1.success){
          this.router.navigate([url]);
        }
      }, (err: any) => {
        // this.spinner.hide();
        this.servicoMsg.exibeErro(err).then(r1 => {});
      });
    }, (err: any) => {
      // this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
